import { /* createAction, */ handleActions } from 'redux-actions';
import api from 'api';
// import util from 'util/baseUtil';


/* 액션 생성 */
const GET_ISSUE_STOCK_LIST = 'stock/GET_ISSUE_STOCK_LIST';
const GET_ISSUE_STOCK_LIST_SUCCESS = 'stock/GET_ISSUE_STOCK_LIST_SUCCESS';
const GET_ISSUE_STOCK_LIST_ERROR = 'stock/GET_ISSUE_STOCK_LIST_ERROR';

const GET_STOCK_DETAIL = 'stock/GET_STOCK_DETAIL';
const SET_STOCK_POSTING = 'stock/SET_STOCK_POSTING';
const SET_STOCK_STATS = 'stock/SET_STOCK_STATS';
const SET_STOCK_DATA = 'stock/SET_STOCK_DATA';

const SET_STOCK_CODE_MAP = 'stock/SET_STOCK_CODE_MAP';

// export const initStockCodeMap = createAction(INIT_STOCK_CODE_MAP); 


/* redux-thunk */
/**
 * 종목코드 초기화
 * @param {*} params 
 */
export const initStockCodeMap = params => async (dispatch, getState) => {
  let lastUpdate = getState().stock.stockCodeMap.lastUpdate;
  const now = new Date().getTime();
  const interval = 60*60*1000;    //업데이트 인터벌 = 60분
  if (lastUpdate === 0) { 
    //최초 수행일경우 세션스토리지 데이터로 초기화
    let stockMap = sessionStorage.getItem('stockCodeMap') ? JSON.parse(sessionStorage.getItem('stockCodeMap')) : null;
    if (stockMap) {
      //업데이트
      dispatch({ type: SET_STOCK_CODE_MAP, payload: stockMap });
      lastUpdate = stockMap.lastUpdate;
    }
  }
  if (now - lastUpdate < interval) {
    // console.log('최신 종목코드 데이터 입니다.')
    return; //마지막 업데이트가 인터벌 시간 이내일경우 업데이트 안함.
  }

  //서버에서 종목정보 업데이트
  try {
    const responseData = await api.stock.getListStockCode();
    let stocks = responseData.split('\n');
    
    let codeMap = {};
    let nameMap = {};

    for (let i = 0; i < stocks.length; i++) {
      let stock = stocks[i].split('\t');

      codeMap[stock[0]] = stock[1];
      nameMap[stock[1]] = stock[0];
      // console.log(i,'번째 종목 코드 : ',stock[0], '종목 명 : ',stock[1]);
    }
    let stockCodeMap = {
      codeMap: codeMap,
      nameMap: nameMap,
      lastUpdate: new Date().getTime(),
    };
    dispatch({ type: SET_STOCK_CODE_MAP, payload: stockCodeMap});

    sessionStorage.setItem('stockCodeMap', JSON.stringify(stockCodeMap));
  } catch(e) {
    // console.error(e);
    throw e;
  }
}


/**
 * 이슈종목 목록 가져오기
 */
export const getListIssueStock = () => async (dispatch, getState) => {
  dispatch({ type: GET_ISSUE_STOCK_LIST });
  try {
    const responseData = await api.stock.getListIssueStock();
    dispatch({ type: GET_ISSUE_STOCK_LIST_SUCCESS, payload: responseData.IssueStockList });
  } catch(e) {
    console.log(e)
    dispatch({ type: GET_ISSUE_STOCK_LIST_ERROR, payload: `[${e.response.status}] ${e.message}` });
  }

}



/**
 * 데이터 배열을 labels 기준으로 평탄화
 * @param {*} dataArr 
 */
const statsFlatten = dataArr => {
  return (dataArr || []).reduce((acc, curr) => {
    acc[curr.labels] = {
      labels: curr.labels,
      ref_freq_list: curr.ref_freq_list,
    }
    return acc;
  },{});
}
/**
 * 통계 데이터 재가공
 * @param {*} data 
 */
const reprocessStatsData = data => {
  const {stockRoomStats, stockMessageStats1M, stockMessageStats3M, stockMessageStats6M} = data;
  let result = {
    stockRoomStats: stockRoomStats || [],
  }

  const now = new Date();
  let targetDate, period, time;

  //1달
  targetDate = new Date();
  targetDate.setMonth(targetDate.getMonth() - 1);
  period = Math.ceil((now - targetDate)/(1000*60*60*24));

  time = new Date();
  let map1M = statsFlatten(stockMessageStats1M);
  result.stockMessageStats1M = new Array(period).fill(null).map(()=>{
    const lb = `${(time.getFullYear())}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')}`;
    time.setDate(time.getDate()-1);

    return {
      labels: lb,
      ref_freq_list: map1M[lb] ? (map1M[lb].ref_freq_list || "0") : "0",
    }
  }).reverse();

  //3달
  targetDate = new Date();
  targetDate.setMonth(targetDate.getMonth() - 3);
  period = Math.ceil((now - targetDate)/(1000*60*60*24));

  time = new Date();
  let map3M = statsFlatten(stockMessageStats3M);
  result.stockMessageStats3M = new Array(period).fill(null).map(()=>{
    const lb = `${(time.getFullYear())}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')}`;
    time.setDate(time.getDate()-1);

    return {
      labels: lb,
      ref_freq_list: map3M[lb] ? (map3M[lb].ref_freq_list || "0") : "0",
    }
  }).reverse();

  //6달
  targetDate = new Date();
  targetDate.setMonth(targetDate.getMonth() - 6);
  period = Math.ceil((now - targetDate)/(1000*60*60*24));

  time = new Date();
  let map6M = statsFlatten(stockMessageStats6M);
  result.stockMessageStats6M = new Array(period).fill(null).map(()=>{
    const lb = `${(time.getFullYear())}-${(time.getMonth() + 1).toString().padStart(2, '0')}-${time.getDate().toString().padStart(2, '0')}`;
    time.setDate(time.getDate()-1);

    return {
      labels: lb,
      ref_freq_list: map6M[lb] ? (map6M[lb].ref_freq_list || "0") : "0",
    }
  }).reverse();

  // console.log('통계데이터 결과',result)

  return result;
}


/**
 * 종목 상세 가져오기
 * @param {obj} params {stock_code: 종목코드, stock_name: 종목명}
 */
export const getStockDetail = params => async (dispatch, getState) => {
  // const {stock_code, stock_name, stockDetail} = params;
  const {stock_code, stock_name} = params;
  if (!stock_code || !stock_name) {
    throw new Error(`[getStockDetail]파라미터 오류 - stock_code: ${stock_code} / stock_name: ${stock_name}`);
  }

  api.stock.cancelRequestDetail();
  dispatch({ type: GET_STOCK_DETAIL, payload: params });


  /* 공시, 뉴스 */
  let getStockPosting = api.stock.getStockPosting(params).then(responseData => { // eslint-disable-line no-unused-vars
    if (responseData.result !== 'S') {
      return;
    }
    dispatch({ type: SET_STOCK_POSTING, payload: responseData });
  }).catch(e => {
    if (e.message !== 'cancel' && (!e.response || e.response.status !== 403)) {
      throw e;
    }
  });

  /* 통계 데이터 */
  let getStockStats = api.stock.getStockStats(params).then(responseData => {  // eslint-disable-line no-unused-vars
    if (responseData.result !== 'S') {
      return;
    }
    dispatch({ type: SET_STOCK_STATS, payload: reprocessStatsData(responseData) });
  }).catch(e => {
    if (e.message !== 'cancel' && (!e.response || e.response.status !== 403)) {
      throw e;
    }
  });

  /* 상세 데이터 */
  let getStockData = api.stock.getStockData(params).then(responseData => {  // eslint-disable-line no-unused-vars
    if (responseData.result !== 'S') {
      return;
    }
    dispatch({ type: SET_STOCK_DATA, payload: responseData });
  }).catch(e => {
    if (e.message !== 'cancel' && (!e.response || e.response.status !== 403)) {
      throw e;
    }
  });
  
  


  // Promise.all([getStockPosting, getStockStats, getStockData]).then(() => {
  // // Promise.all([getStockPosting, getStockStats, getStockData]).then(() => {
  //   // console.log('종목상세 가져오기 완료');
  // }).catch(e => {
  //   if (e.message !== 'cancel' && e.response.status !== 403) {
  //     throw e;
  //   }
  // });


}


/* 초기상태 설정(immutable) */
const initialState = {
  stockCodeMap: {
    codeMap: {},
    nameMap: {},
    lastUpdate: 0,
  },
  issueStockList: {
    loading: false,
    data: [],
    error: null,
  },
  detail: {
    stock_code: null,
    stock_name: null,
    loading: {
      data: false,
      post: false,
      stats: false,
    },
    data: {},
    post: {
      news: [],
      dart: [],
    },
    stats: {
      room: [],
      message: {
        month1: [],
        month3: [],
        month6: [],
      },
    },
  },

};

/* 리듀서 정의 */
export default handleActions({
  [SET_STOCK_CODE_MAP]: (state, action) => {
    return {
      ...state,
      stockCodeMap: action.payload,
    }
  },
  [GET_ISSUE_STOCK_LIST]: (state, action) => {
    return {
      ...state,
      issueStockList: {
        ...state.issueStockList,
        loading: true,
        error: null,
      }
    }
  },
  [GET_ISSUE_STOCK_LIST_SUCCESS]: (state, action) => {
    return {
      ...state,
      issueStockList: {
        ...state.issueStockList,
        loading: false,
        data: action.payload,
      }
    }
  },
  [GET_ISSUE_STOCK_LIST_ERROR]: (state, action) => {
    return {
      ...state,
      issueStockList: {
        ...state.issueStockList,
        loading: false,
        error: action.payload,
      }
    }
  },
  [GET_STOCK_DETAIL]: (state, action) => {
    const {stock_code, stock_name} = action.payload;
    return {
      ...state,
      detail: {
        stock_code: stock_code,
        stock_name: stock_name,
        loading: {
          data: true,
          post: true,
          stats: true,
        },
        data: {},
        post: {
          news: [],
          dart: [],
        },
        stats: {
          room: [],
          message: {
            month1: [],
            month3: [],
            month6: [],
          },
        },
      },
    }
  },
  [SET_STOCK_POSTING]: (state, action) => {
    const {stockDartList, stockNewsList} = action.payload;
    return {
      ...state,
      detail: {
        ...state.detail,
        loading: {
          ...state.detail.loading,
          post: false,
        },
        post: {
          news: stockNewsList || [],
          dart: stockDartList || [],
        },
      },
    }
  },
  [SET_STOCK_STATS]: (state, action) => {
    const {stockRoomStats, stockMessageStats1M, stockMessageStats3M, stockMessageStats6M} = action.payload;
    return {
      ...state,
      detail: {
        ...state.detail,
        loading: {
          ...state.detail.loading,
          stats: false,
        },
        stats: {
          room: stockRoomStats || [],
          message: {
            month1: stockMessageStats1M || [],
            month3: stockMessageStats3M || [],
            month6: stockMessageStats6M || [],
          },
        },
      },
    }
  },
  [SET_STOCK_DATA]: (state, action) => {
    const {stockData} = action.payload;
    return {
      ...state,
      detail: {
        ...state.detail,
        loading: {
          ...state.detail.loading,
          data: false,
        },
        data: stockData || {},
      },
    }
  },

  
}, initialState)